import { SPBFFProvider } from '@group-link-one/gl-ui/sonarprint';
import { AuthProvider, SentryProvider } from '@group-link-one/gl-utils';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'react-day-picker/style.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { bffConfig } from './BFF/config.ts';
import { env } from './env.ts';
import { AnalyticsProviders } from './providers/AnalyticsProviders.tsx';
import { queryClient } from './Services/queryClient.ts';
import { CookieConsentProvider } from './utils/cookiesSetup.ts';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <SentryProvider
    config={{
      environment: env.VITE_SENTRY_ENVIRONMENT ?? '',
      dsn: env.VITE_SENTRY_DSN ?? '',
      appVersion: __PACKAGE_VERSION__ ?? '',
      // Only send events in production — local dev errors must never mix with
      // real user data, regardless of what DSN happens to be in the local
      // (gitignored) .env. Branded env files use the literal 'production'
      // here (not 'prod', unlike the other GL dashboards).
      enabled: env.VITE_NODE_ENV === 'production',
    }}
  >
    <QueryClientProvider client={queryClient}>
      <AuthProvider
        baseURL={env.VITE_REACT_APP_API_URL}
        keyStorage={`@sonarprint-${env.VITE_NODE_ENV}`}
      >
        <CookieConsentProvider>
          <SPBFFProvider config={bffConfig}>
            <BrowserRouter>
              <AnalyticsProviders>
                <App />
              </AnalyticsProviders>
              <ReactQueryDevtools />
            </BrowserRouter>
          </SPBFFProvider>
        </CookieConsentProvider>
      </AuthProvider>
    </QueryClientProvider>
  </SentryProvider>,
);
